var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.554,
    height: 15.566,
    viewBox: "2698 4700 13.554 15.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2707.31 4715.566h-6.878a2.435 2.435 0 0 1-2.432-2.432v-10.702a2.435 2.435 0 0 1 2.432-2.432h6.879a.73.73 0 0 1 .73.73.73.73 0 0 1-.73.73h-6.879a.974.974 0 0 0-.973.972v10.702c0 .537.436.972.973.973h6.879a.73.73 0 0 1 0 1.459Zm4.03-8.299-3.467-3.467a.726.726 0 0 0-.372-.2.73.73 0 0 0-.622.164.74.74 0 0 0-.038.036.726.726 0 0 0-.2.372c-.045.231.021.48.2.66l2.222 2.221h-5.744a.73.73 0 0 0-.73.73c0 .403.327.73.73.73h5.744l-2.222 2.221a.726.726 0 0 0-.2.373.73.73 0 0 0 .165.622.74.74 0 0 0 .035.037.726.726 0 0 0 .373.2.73.73 0 0 0 .622-.165.74.74 0 0 0 .037-.035l3.468-3.467a.726.726 0 0 0 .2-.372.73.73 0 0 0-.165-.622.74.74 0 0 0-.035-.038Z",
    fill: "#2a2a2a",
    fillRule: "evenodd",
    "data-name": "logout"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.753ee319731988aefef7b80d9163bb33.svg";
export { ForwardRef as ReactComponent };